define('casino/billboard',['module', 'jquery', 'all/player/session', 'all/jquery/jquery.mustache'], function (module, $, session) {
	'use strict';
	var configuration = module.config();
	var billboards = configuration.billboards;

    function update(slides) {
        var $billboard = $('#cnt-billboard');
        $billboard.scrollerStop();
        $billboard.empty();
        if(slides.length > 0) {
            $.Mustache.addFromDom('billboard-template');
            $billboard.mustache('billboard-template', {billboards: slides});
            $billboard.scroller({direction: 'left'});
        }
    }

	function onLogin() {
        if( typeof billboards !== 'undefined') {
            update(billboards.loggedIn);
        }
	}

	function onLogout() {
        if (typeof billboards !== 'undefined') {
            update(billboards.loggedOut);
        }
	}

	$(session).on('login', onLogin);
	$(session).on('logout', onLogout);

	function init() {
		$('#cnt-billboard').scroller({direction: 'left'});
		if (session.authenticated) {
			onLogin();
		} else {
			onLogout();
		}
	}

	var billboard = {};
	billboard.init = init;
	return billboard;

});

